import { render, staticRenderFns } from "./addEditDialog.vue?vue&type=template&id=21812590&scoped=true"
import script from "./addEditDialog.vue?vue&type=script&lang=js"
export * from "./addEditDialog.vue?vue&type=script&lang=js"
import style0 from "./addEditDialog.vue?vue&type=style&index=0&id=21812590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21812590",
  null
  
)

export default component.exports